import { render, staticRenderFns } from "./adminNotification.vue?vue&type=template&id=258cb552"
import script from "./adminNotification.vue?vue&type=script&lang=js"
export * from "./adminNotification.vue?vue&type=script&lang=js"
import style0 from "./adminNotification.vue?vue&type=style&index=0&id=258cb552&prod&lang=css"
import style1 from "./adminNotification.vue?vue&type=style&index=1&id=258cb552&prod&slot-scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports